import Loader from '@/components/UIComponents/Loader.vue'
import Progress from '@/components/UIComponents/Progress'
import BaseModal from '@/components/UIComponents/BaseModal.vue'
import BaseOverlay from '@/components/UIComponents/BaseOverlay.vue'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component('loader', Loader)
    Vue.component('v-progress', Progress)
    Vue.component('base-modal', BaseModal)
    Vue.component('base-overlay', BaseOverlay)
  }
}

export default GlobalComponents
